(function () {
  var overlay = document.getElementById('hlfm-overlay');
  var modal = document.getElementById('hlfm-modal');
  if (!overlay || !modal) return;

  var steps = modal.querySelectorAll('[data-hlfm-step]');
  var dots = modal.querySelectorAll('[data-hlfm-dot]');
  var btnPrev = modal.querySelector('[data-hlfm-prev]');
  var btnNext = modal.querySelector('[data-hlfm-next]');
  var state = { step: 0, height: null, distance: null };

  var BIKES = {
    y3: {
      handle: 'y3-standard',
      name: 'Y3',
      price: 'Rs. 25,999',
      image: 'hl-product-y3-black.png',
      features: ['7.8Ah Battery', '40 km Range', 'Single Speed', '250W BLDC Motor']
    },
    y3plus: {
      handle: 'y3-plus',
      name: 'Y3 Plus',
      price: 'Rs. 29,999',
      image: 'hl-product-y3plus-black.png',
      features: ['10.4Ah Detachable Battery', '60 km Range', 'LCD Display', 'Key Ignition']
    },
    y5: {
      handle: 'y5-standard',
      name: 'Y5',
      price: 'Rs. 32,999',
      image: 'hl-product-y5-blue.png',
      features: ['10.4Ah Battery', '60 km Range', 'Single Speed', '100mm Suspension']
    },
    y5plus: {
      handle: 'y5-plus',
      name: 'Y5 Plus',
      price: 'Rs. 36,999',
      image: 'hl-product-y5-blue.png',
      features: ['10.4Ah Detachable Battery', '60 km Range', '7-Speed Shimano', 'LCD Display']
    }
  };

  var RECOMMENDATIONS = {
    distance1: { type: 'redirect', url: '/collections/all' },
    distance2: {
      type: 'single',
      bike: 'y3plus',
      sub: 'Detachable battery and LCD display for everyday commutes.'
    },
    distance3: {
      type: 'single',
      bike: 'y5',
      sub: '60 km range with 100mm suspension for longer rides and varied terrain.'
    },
    distance4: {
      type: 'multi',
      bikes: ['y3plus', 'y5', 'y5plus'],
      sub: 'Any of these three e-cycles can handle 60 km on a single charge. Pick the one that matches your style.'
    }
  };

  function open() {
    overlay.classList.add('is-open');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    goTo(0);
  }
  function close() {
    overlay.classList.remove('is-open');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function goTo(idx) {
    state.step = idx;
    steps.forEach(function (s, i) {
      s.style.display = i === idx ? '' : 'none';
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
    if (btnPrev) btnPrev.style.visibility = idx === 0 ? 'hidden' : 'visible';
    if (btnNext) {
      if (idx === steps.length - 1) {
        btnNext.style.display = 'none';
      } else if (idx === steps.length - 2) {
        btnNext.style.display = '';
        btnNext.textContent = 'Find my e-cycle →';
      } else {
        btnNext.style.display = '';
        btnNext.textContent = 'Next →';
      }
    }
    updateNextDisabled();
  }
  function updateNextDisabled() {
    if (!btnNext) return;
    var ok = true;
    if (state.step === 0 && !state.height) ok = false;
    if (state.step === 1 && !state.distance) ok = false;
    btnNext.disabled = !ok;
  }
  function assetUrl(key) {
    return (window.HLFM_ASSETS && window.HLFM_ASSETS[key]) || '';
  }
  function cardHtml(bike, compact) {
    var cls = compact ? 'hlfm-bcard hlfm-bcard--compact' : 'hlfm-bcard';
    return (
      '<div class="' + cls + '">' +
        '<img class="hlfm-bcard__img" src="' + assetUrl(bike.image) + '" alt="' + bike.name + '">' +
        '<h4 class="hlfm-bcard__name">Hero Lectro ' + bike.name + '</h4>' +
        '<p class="hlfm-bcard__price">' + bike.price + '</p>' +
        '<ul class="hlfm-bcard__features">' +
          bike.features.map(function (f) { return '<li>' + f + '</li>'; }).join('') +
        '</ul>' +
        '<a class="hlfm-btn hlfm-btn--sm" href="/pages/' + bike.handle + '">View Details</a>' +
      '</div>'
    );
  }
  function showResult() {
    var rec = RECOMMENDATIONS[state.distance];
    if (!rec) return;

    if (rec.type === 'redirect') {
      close();
      window.location.href = rec.url;
      return;
    }

    var resultStep = modal.querySelector('[data-hlfm-result]');
    if (!resultStep) return;

    var html;
    if (rec.type === 'single') {
      var bike = BIKES[rec.bike];
      html =
        '<div class="hlfm-result">' +
          '<p class="hlfm-result__eyebrow">Your match</p>' +
          '<h3 class="hlfm-result__title">Hero Lectro ' + bike.name + '</h3>' +
          '<p class="hlfm-result__sub">' + rec.sub + '</p>' +
          '<img class="hlfm-result__img" src="' + assetUrl(bike.image) + '" alt="' + bike.name + '">' +
          '<p class="hlfm-result__price">' + bike.price + '</p>' +
          '<div class="hlfm-result__features">' +
            bike.features.map(function (f) { return '<span class="hlfm-result__feature">' + f + '</span>'; }).join('') +
          '</div>' +
          '<div class="hlfm-result__actions">' +
            '<a class="hlfm-btn" href="/pages/' + bike.handle + '">View Details</a>' +
            '<button type="button" class="hlfm-btn hlfm-btn--ghost" data-hlfm-restart>Start Over</button>' +
          '</div>' +
        '</div>';
    } else if (rec.type === 'multi') {
      var cards = rec.bikes.map(function (k) { return cardHtml(BIKES[k], true); }).join('');
      html =
        '<div class="hlfm-result hlfm-result--multi">' +
          '<p class="hlfm-result__eyebrow">Your top matches</p>' +
          '<h3 class="hlfm-result__title">Three e-cycles for long rides</h3>' +
          '<p class="hlfm-result__sub">' + rec.sub + '</p>' +
          '<div class="hlfm-result__grid">' + cards + '</div>' +
          '<div class="hlfm-result__actions">' +
            '<button type="button" class="hlfm-btn hlfm-btn--ghost" data-hlfm-restart>Start Over</button>' +
          '</div>' +
        '</div>';
    }

    resultStep.innerHTML = html;
    var restart = resultStep.querySelector('[data-hlfm-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        state.height = null;
        state.distance = null;
        modal.querySelectorAll('.hlfm-option.is-active').forEach(function (o) { o.classList.remove('is-active'); });
        goTo(0);
      });
    }
    goTo(steps.length - 1);
  }

  modal.addEventListener('click', function (e) {
    var opt = e.target.closest('.hlfm-option');
    if (!opt) return;
    var group = opt.getAttribute('data-group');
    var val = opt.getAttribute('data-value');
    if (!group || !val) return;
    modal.querySelectorAll('.hlfm-option[data-group="' + group + '"]').forEach(function (o) {
      o.classList.remove('is-active');
    });
    opt.classList.add('is-active');
    state[group] = val;
    updateNextDisabled();
  });

  if (btnNext) btnNext.addEventListener('click', function () {
    if (btnNext.disabled) return;
    if (state.step === steps.length - 2) {
      showResult();
    } else {
      goTo(state.step + 1);
    }
  });
  if (btnPrev) btnPrev.addEventListener('click', function () {
    if (state.step > 0) goTo(state.step - 1);
  });

  document.querySelectorAll('[data-hlfm-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  overlay.addEventListener('click', close);
  modal.querySelectorAll('[data-hlfm-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
